module.exports = __webpack_public_path__ + "83844e780e84aad0d812a6e4a7b2d9e9.jpg";